let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fW9ia")).then(() => parcelRequire('jBFjy'));